/************************************************
 * src/components/RedmineExtendedData.js
 * This shows *both* trackers: "License Requests" + "AIMS License Requests"
 ************************************************/
import React from 'react';
import DataTable from 'react-data-table-component';
import PropTypes from 'prop-types';
import './styles/RedmineExtendedData.css';

const RedmineExtendedData = ({ data, maxSubprojects }) => {
  const [searchQuery, setSearchQuery] = React.useState('');

  // build columns dynamically based on maxSubprojects
  const columns = React.useMemo(() => {
    if (!data || data.length === 0) return [];
    const baseCols = [
      { name: 'Ticket #', selector: (row) => row['Ticket #'], sortable: true, width: '8%' },
      { name: 'Source', selector: (row) => row['Source'], sortable: true, width: '10%' },
      { name: 'Company', selector: (row) => row['Company'], sortable: true, width: '12%' },
      { name: 'Subject', selector: (row) => row['Subject'], width: '18%' },
      { name: 'Description', selector: (row) => row['Description'], width: '20%' },
      { name: 'Status', selector: (row) => row['Status'], sortable: true, width: '8%' },
      { name: 'Approval', selector: (row) => row['Approval'], width: '8%' },
      { name: 'License Requests', selector: (row) => row['License Requests'], width: '10%' },
      { name: 'Created On', selector: (row) => row['Created On'], sortable: true, width: '12%' },
    ];
    // subproject columns
    const subCols = [];
    for (let i = 1; i <= maxSubprojects; i++) {
      subCols.push({
        name: `Subproject ${i}`,
        selector: (row) => row[`Subproject ${i}`],
        sortable: true,
        width: '12%',
      });
    }
    return [...baseCols, ...subCols];
  }, [data, maxSubprojects]);

  const filteredData = React.useMemo(() => {
    if (!searchQuery) return data || [];
    const q = searchQuery.toLowerCase();
    return (data || []).filter((row) =>
      Object.values(row).some((val) => val && val.toString().toLowerCase().includes(q))
    );
  }, [data, searchQuery]);

  return (
    <div className="extended-data-container">
      <div className="search-container" style={{ marginBottom: '10px' }}>
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="search-input"
          style={{ padding: '6px', borderRadius: '4px' }}
        />
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination
        highlightOnHover
        pointerOnHover
        customStyles={{
          table: {
            style: {
              width: '100%',
              overflowX: 'auto',
            },
          },
          headRow: {
            style: {
              backgroundColor: '#2a3b50',
              color: 'white',
            },
          },
          rows: {
            style: {
              minHeight: '60px',
            },
            highlightOnHoverStyle: {
              backgroundColor: 'rgba(0, 17, 255, 0.1)',
              boxShadow: '0 4px 10px rgba(0, 0, 0, 0.4)',
            },
          },
        }}
      />
    </div>
  );
};

RedmineExtendedData.propTypes = {
  data: PropTypes.array.isRequired,
  maxSubprojects: PropTypes.number.isRequired,
};

export default RedmineExtendedData;
